// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.video-instruction-step .viewport
{
	height: 310px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/Steps/VideoInstructionStep.css"],"names":[],"mappings":";AACA;;CAEC,aAAa;CACb,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB","sourcesContent":["\n.video-instruction-step .viewport\n{\n\theight: 310px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
